import { forwardRef } from 'react';

import { SearchIcon } from '@/assets/icons';
import { IInput, Input } from '@/components/common';

const Search = forwardRef<HTMLInputElement, IInput>(({ ...props }, ref) => {
  return <Input ref={ref} prefix={SearchIcon} {...props} />;
});

Search.displayName = 'Search';

export { Search };
